export type PlanDimDraftSelections = Record<string, string[]>;

export const buildActiveDimFilterSubsetsFromDraft = (
  draft: PlanDimDraftSelections,
  visibleDimensions: Array<{ name: string; items: string[] }>,
): Record<string, string[]>[] =>
  visibleDimensions
    .map((dimension) => {
      const selected = draft[dimension.name] ?? [];
      if (selected.length > 0 && selected.length < dimension.items.length) {
        return { [dimension.name]: [...selected] };
      }
      return null;
    })
    .filter((entry): entry is Record<string, string[]> => entry != null);

export const selectionsFromRedux = (selectedBlockDimension: any[]): PlanDimDraftSelections => {
  const draft: PlanDimDraftSelections = {};
  (selectedBlockDimension ?? []).forEach((entry) => {
    const dimensionName = Object.keys(entry ?? {})[0];
    if (!dimensionName) return;
    draft[dimensionName] = Array.isArray(entry[dimensionName]) ? [...entry[dimensionName]] : [];
  });
  return draft;
};

export const selectionsToRedux = (draft: PlanDimDraftSelections) =>
  Object.entries(draft).map(([name, items]) => ({ [name]: items }));

export const buildDefaultDraft = (
  dimensions: Array<{ name: string; items: string[] }>,
): PlanDimDraftSelections => {
  const draft: PlanDimDraftSelections = {};
  dimensions.forEach((dimension) => {
    draft[dimension.name] = [...(dimension.items ?? [])];
  });
  return draft;
};

/** Builds modal draft state from applied Redux filters plus full dimension metadata. */
export const buildDraftFromFilterSource = (
  filterSource: any[] | null | undefined,
  visibleDimensions: Array<{ name: string; items: string[] }>,
): PlanDimDraftSelections => {
  const draft = buildDefaultDraft(visibleDimensions);
  const partial = selectionsFromRedux(filterSource ?? []);

  Object.entries(partial).forEach(([name, items]) => {
    if (!Array.isArray(items) || !(name in draft)) return;
    draft[name] = items.filter((item) => draft[name].includes(item));
  });

  return draft;
};

export const countActiveFilterItems = (source: any[]) =>
  (source ?? []).reduce((count: number, item: any) => {
    const values = Object.values(item ?? {})[0];
    return count + (Array.isArray(values) ? values.length : 0);
  }, 0);
